module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/eliminar-pill-ub.206b1792.svg";